/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const QuestionAnswerFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M8 18h10.24L20 19.39V9h1a1 1 0 0 1 1 1v13.5L17.55 20H9a1 1 0 0 1-1-1zm-2.55-2L1 19.5V4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v12z" />
  </Icon>
);
